import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { translate } from 'react-i18next'
import WordPressApi from './services/wpapi'
import './utils/polyfills/findIndex'
import './utils/polyfills/includes'

// Pages
import Index from './pages/Index'
import Single from './pages/Single'
import Page from './pages/Page'
import NotFound from './pages/NotFound'

// Components
import Transition from './components/Transition'
import Header from './components/Header'
import Menu from './components/Menu'
import MenuButton from './components/Menu/MenuButton'
import MainSlider from './components/MainSlider'
import Splashscreen from './components/Splashscreen'
import DesktopOverlay from './components/Global/DesktopOverlay'
import TurnScreen from './components/Global/TurnScreen'
import Notification from './components/Global/Notification'

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpened: false,
      mainSlider: undefined,
      options: null,
      pages: null,
      trips: [],
      initialSlide: 0,
      wpforms: {},
    }

    this.handleInitialSlide = this.handleInitialSlide.bind(this)
    this.closeNav = this.closeNav.bind(this)
    this.toggleNav = this.toggleNav.bind(this)
  }
  async componentDidMount() {
    const { history } = this.props
    const options = await WordPressApi.options.all()
    const pages = await WordPressApi.pages.all()
    const trips = await WordPressApi.trips.all()
    const wpforms = await WordPressApi.wpforms.getById(options.acf.id_form_pwa)
    const initialSlide =
      trips.findIndex(trip => window.location.pathname.includes('/' + trip.slug)) !== -1
        ? trips.findIndex(trip => window.location.pathname.includes('/' + trip.slug))
        : 0

    this.setState({
      options,
      pages: pages.filter(page => page.acf.enable_in_pwa),
      trips,
      initialSlide,
      mainSlider: this.mainSlider,
      wpforms: {
        fields: wpforms.fields,
        id: wpforms.id,
        page_id: wpforms.settings.confirmation_page,
      },
    })

    if (history.location && history.location.state && history.location.state.to) {
      const state = { ...history.location.state }
      delete state.to
      history.replace({ ...history.location, state })
    }

    // Update Main Slider from window.location.pathname
    this.mainSlider.slickGoTo(initialSlide)
  }
  handleInitialSlide(index) {
    this.setState({
      initialSlide: index
    })
  }
  /**
   * Close menu
   */
  closeNav() {
    document.body.classList.add('menu--opened')

    this.setState({
      menuOpened: false
    })
  }
  /**
   * Toggle body class that determines if menu is opened or not
   */
  toggleNav() {
    const { menuOpened } = this.state

    document.body.classList.contains('menu--opened')
      ? document.body.classList.remove('menu--opened')
      : document.body.classList.add('menu--opened')

    this.setState({
      menuOpened: !menuOpened
    })
  }
  render() {
    const SITE_TITLE = 'Domaine Elisabeth'
    const { location, t } = this.props
    const {
      initialSlide,
      mainSlider,
      menuOpened,
      options,
      pages,
      trips,
      wpforms
    } = this.state
    const mainSliderSettings = {
      fade: true,
      dots: false,
      arrows: false,
      infinite: true,
      initialSlide,
      ref: slider => (this.mainSlider = slider),
    }

    return (
      <div className="main">
        {/* Offline Message */}
        {!navigator.onLine && <Notification message={ t('notification.offline') } />}
        {/* Loader */}
        <TransitionGroup>
          {trips.length === 0 && (
            <CSSTransition classNames="fade" timeout={700}>
              <Splashscreen />
            </CSSTransition>
          )}
        </TransitionGroup>
        {/* Desktop Message */}
        {options && <DesktopOverlay options={options} />}
        {/* Turn Screen */}
        <TurnScreen />
        {/* Header */}
        <Header handleNavClick={this.closeNav}  />
        {/* Menu */}
        <MenuButton menuOpened={menuOpened} handleNavClick={this.toggleNav} />
        <TransitionGroup>
          {(menuOpened && trips) && (
            <CSSTransition classNames="fade" timeout={700}>
              <Menu
                handleNavClick={this.toggleNav}
                pages={pages}
                trips={trips}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
        {/* MainSlider */}
        <MainSlider
          sliderSettings={mainSliderSettings}
          initialSlide={initialSlide}
          trips={trips}
        />
        <Transition location={location}>
          <Switch location={location}>
            {/* Home */}
            {trips.length > 0 && (
              <Route
                exact
                path="/"
                render={routeProps => (
                  <Index
                    {...routeProps}
                    bodyClasses={['home']}
                    siteTitle={SITE_TITLE}
                    mainSlider={mainSlider}
                    handleInitialSlide={this.handleInitialSlide}
                    initialSlide={initialSlide}
                    trips={trips}
                  />
                  )}
              />
            )}
            {/* Single Trips */}
            {trips.length > 0 && trips.map(trip => (
              <Route
                path={`/${trip.slug}/:step?`}
                key={trip.id}
                render={routeProps => (
                  <Single
                    {...routeProps}
                    bodyClasses={['single']}
                    options={options}
                    siteTitle={`${SITE_TITLE} — ${trip.title.rendered}`}
                    trip={trip}
                    trips={trips}
                    wpforms={wpforms}
                  />
                )}
              />
            ))}
            {/* Home */}
            {(options && pages) && pages.map(page => (
              <Route
                key={page.id}
                exact
                path={`/${page.slug}`}
                render={routeProps => (
                  <Page
                    {...routeProps}
                    bodyClasses={['page']}
                    options={options}
                    page={page}
                    siteTitle={`${SITE_TITLE} — ${page.title.rendered}`}
                  />
                )}
              />
            ))}
            {/* Page 404 */}
            {options && <Route render={routeProps => <NotFound {...routeProps} bodyClasses={['page', 'error-404']} options={options} />} />}
          </Switch>
        </Transition>
      </div>
    )
  }
}

export default translate('common')(withRouter(App))


// WEBPACK FOOTER //
// ./src/App.js